/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@chakra-ui/react';
import { Card, CardContent, CardHeader, CardTitle } from '@mesh.ai/rabbit';
import ReactWordcloud from 'react-wordcloud';
import 'tippy.js/animations/scale.css';
import 'tippy.js/dist/tippy.css';

import { TextLabel } from 'uiToolkitV1/Typography';

import { WORD_CLOUD_WORDS } from '../constants';

const callbacks = {
  getWordColor: ({ color }) => color ?? '#44812F',
  onWordClick: console.log,
  onWordMouseOver: console.log,
  getWordTooltip: (word) => word?.text,
};
const options = {
  rotations: 2,
  rotationAngles: [-90, 0],
  fontSizes: [20, 60],
  padding: 3,
  fontFamily: 'Arial',
  deterministic: true,
};

const WordCloud = ({ words = WORD_CLOUD_WORDS }) => {
  const wrapperRef = useRef(null);
  const [wrapperHeight, setWrapperHeight] = useState(0);
  const [wrapperWidth, setWrapperWidth] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const calculateElementDimensions = () => {
    const wrapperElement = wrapperRef?.current || {};
    const { clientHeight, clientWidth } = wrapperElement;
    setWrapperHeight(clientHeight);
    setWrapperWidth(clientWidth);
  };

  // when the element loads, wrapperRef gets a definition
  useEffect(() => {
    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (wrapperRef?.current) {
      visibilityObserver.observe(wrapperRef.current);
    }
    return () => {
      if (wrapperRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        visibilityObserver.unobserve(wrapperRef.current);
      }
    };
  }, [wrapperRef]);

  // when the card is resized, expanded or collapsed
  useEffect(() => {
    const handleResize = () => {
      if (wrapperRef.current) {
        calculateElementDimensions();
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);

    if (wrapperRef.current) {
      resizeObserver.observe(wrapperRef.current);
      handleResize();
    }

    // Cleanup on unmount
    return () => {
      if (wrapperRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        resizeObserver.unobserve(wrapperRef.current);
      }
    };
  }, [wrapperHeight, wrapperWidth]);

  // calculate the initial dimensions when wrapperRef gets a value
  useEffect(() => {
    calculateElementDimensions();
  }, [isVisible]);

  return (
    <Card style={{ height: '100%', padding: '12px' }}>
      <CardHeader>
        <CardTitle style={{ color: '#666', fontSize: '12px', fontWeight: 'bold' }}>Expected characteristics</CardTitle>
      </CardHeader>
      <CardContent style={{ height: 'calc(100% - 50px)' }} ref={wrapperRef}>
        <ReactWordcloud callbacks={callbacks} options={options} words={words} size={[wrapperWidth, wrapperHeight]} />
        <Box p="4px" mt="4px">
          <TextLabel color="#666">Common characteristics word cloud across all the high relevance profile. </TextLabel>
        </Box>
      </CardContent>
    </Card>
  );
};

export default WordCloud;
